import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';

export const Title = styled.h1`
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-weight: 600;
    color: #000;
    padding: 66px 0 0 33px;
    font-size: 44px;
    @media screen and (max-width: 1919px) {
    padding: 33px 0 0 33px;
    font-size: 30px; 
  }  
  @media screen and (max-width: ${ScreenSize.tablet}px) {
        padding: 33px 0 0 33px;
        font-size: 20px;
  }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        padding: 33px 0 0 0;
        font-size: 20px;
  }
`;

export const BoxEasyFast = styled.div`
    background-color: #fff;
    padding: 0 50px;
    @media screen and (max-width: ${ScreenSize.tabletPlus}px) {
        padding: 0 30px;
  }
`;
